export function normalizeArrayToObject<T>(array: T[], key: keyof T): Record<string, T> {
  return array.reduce((acc, cur) => ({ ...acc, [cur[key] as string]: cur }), {});
}
